import React, { Component} from "react";
import {Button} from 'react-bootstrap'
import {
  NavLink
} from "react-router-dom";

class DumbButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
     exists: false
    };
  }
  componentDidMount() {
  this.interval = setInterval(() => this.setState({ exists: true }), 100);
  } 

 render() {
   if (sessionStorage.getItem("fileName") === null || sessionStorage.getItem("fileName") === "") {
      return (
              <Button  style = {{color: "white"}} variant="success" size="lg" block disabled>
               Continue
              </Button>
      );
    } else {
      return (
       <NavLink to="/Options">
              <Button  style = {{color: "white"}} variant="success" size="lg" block>
               Continue
              </Button>
       </NavLink>
);
    }
  }
}
export default DumbButton;

